module.exports = __webpack_public_path__ + "526b38efc533a1f57d6014b04a152c86.jpg";